const priorityList = [
  {id: 4545554, name: 'High', type: 1, color: '#dc3545'},
  {id: 9384234, name: 'Medium', type: 2, color: '#0d6efd'},
  {id: 4354454, name: 'Low', type: 3, color: '#198754'},
];
export default priorityList;
